export default __webpack_public_path__ + "static/media/mobile.f936ff6c.jpg";